import { createLogic } from 'redux-logic'
import { map, catchError } from 'rxjs/operators'
import * as constants from '../constants'
import Comps from '@engine/comps'
import User from '@engine/user'
import { throwError } from 'rxjs'
import { getUtcDateFormat } from '@engine/utils/format'

export const updateCompsProject = createLogic({
  type: constants.UPDATE_COMPS_PROJECT.ACTION,
  processOptions: {
    dispatchReturn: false
  },
  process({ http, action, getState }, dispatch, done) {

    const state = getState()
    const compsData = Comps.selectors.comps.compsData(state) || state.compsData
    const templateName = Comps.selectors.comps.templateName(state) || state.templateName
    let projectName = Comps.selectors.comps.projectName(state) || state.projectName
    if (projectName === undefined) {
      projectName = Comps.selectors.comps.projectNameCopy(state) || state.projectNameCopy
    }
    const toggleSettings = Comps.selectors.comps.toggleSettings(state) || state.toggleSettings
    const templateDataLimits = Comps.selectors.comps.templateDataLimits(state) || state.templateType
    const barChartData = Comps.selectors.comps.barChartData(state)
    const fpBarChartData = Comps.selectors.comps.fpBarChartData(state)
    const fpSummaryData = Comps.selectors.comps.fpSummaryData(state)
    const barChartSettings = Comps.selectors.comps.barChartSettings(state)
    const themeColors = Comps.selectors.comps.themeColors(state)
    const donutChartThemeColors = Comps.selectors.comps.donutChartThemeColors(state)
    const propertyFieldsAll = Comps.selectors.comps.propertyFields(state)
    const propertyFields = propertyFieldsAll
    const subjectPropertyFields = Comps.selectors.comps.subjectPropertyFields(state)
    const selectedProjectId = Comps.selectors.comps.selectedProjectId(state)
    const entityUserGuid = User.selectors.user.entityUserGuid(state)
    const isDeleted = Comps.selectors.comps.isDeleted(state)
    const userEmail = User.selectors.user.email(state)
    const summaryTableColumns = Comps.selectors.comps.summaryTableColumns(state)
    const fpSummaryTableColumnsAll = Comps.selectors.comps.fpSummaryTableColumns(state)
    const fpSummaryTableColumnsFiltered = {}
    for (const key in fpSummaryTableColumnsAll) {
      if (fpSummaryTableColumnsAll.hasOwnProperty(key)) {
        fpSummaryTableColumnsFiltered[key] = fpSummaryTableColumnsAll[key].filter(obj => obj.key !== 'NA')
      }
    }
    const fpSummaryTableColumns = {}
    for (const key in fpSummaryTableColumnsFiltered) {
      if (fpSummaryData && fpSummaryData.some(fpObj => fpObj.type === key)) {
        fpSummaryTableColumns[key] = fpSummaryTableColumnsFiltered[key]
      }
    }
    const summaryDisclaimerText = Comps.selectors.comps.summaryDisclaimerText(state)
    const unitMixTableColumns = Comps.selectors.comps.unitMixTableColumns(state)
    const compsWithSubjectProperty = Comps.selectors.comps.compsWithSubjectProperty(state)
    const isSubjectPropertyDeleted = Comps.selectors.comps.isSubjectPropertyDeleted(state)
    const polarisPropertySearchCriteriaId = Comps.selectors.comps.polarisPropertySearchCriteriaId(state)
    const omniViewPropertyListId = Comps.selectors.comps.omniViewPropertyListId(state)

    const reqPayload = {
      compsData,
      templateDataLimits,
      templateName,
      toggleSettings,
      barChartData,
      fpBarChartData,
      fpSummaryData,
      fpSummaryTableColumns,
      barChartSettings,
      themeColors,
      donutChartThemeColors,
      propertyFields,
      subjectPropertyFields,
      projectName,
      modifiedUserGuid: entityUserGuid,
      modifiedDate: getUtcDateFormat(),
      isExcelData: true,
      isDeleted,
      mapId: '1',
      mapUrl: 'https://mapsqc.berkadia.com/maps#1',
      dealNumber: action.payload.dealNumber,
      isPortfolio: action.payload.isPortfolio,
      office: action.payload.office,
      summaryTableColumns,
      summaryDisclaimerText,
      unitMixTableColumns,
      compsWithSubjectProperty,
      isSubjectPropertyDeleted,
      polarisPropertySearchCriteriaId,
      omniViewPropertyListId
    }

    return http.put(`/comps/project/${selectedProjectId}`, reqPayload)
      .pipe(
        map(http.getBody),
        map(() => {
          dispatch({
            type: constants.UPDATE_COMPS_PROJECT.FULFILLED,
            payload: { ...action.payload, projectGuid: selectedProjectId, status: 'updated' }
          })
        }),
        catchError(err => throwError(err))
      )
      .subscribe(
        () => {
          // eslint-disable-next-line
          window._mtm.push({ 'event': 'updateProject', 'projectName': action.payload.projectName, 'templateType': action.payload.templateName, 'userEmail': userEmail })
          if (action.payload.saveType === 'savedownload') {
            dispatch({
              type: constants.DOWNLOAD_PDF_S3.ACTION
            })
            done()
          }
        },
        err => {
          dispatch({
            type: constants.UPDATE_COMPS_PROJECT.REJECTED,
            payload: err
          })
          done()
        }
      )
  }
})
